var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoJackpotWidget = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.96875H20V5.3125H0V2.96875Z",
    fill: "#fff",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.89844 6.3125H0V15.6875H5.89844V6.3125ZM4.72656 10.6567L4.5549 10.8283C3.91922 11.464 3.55469 12.3441 3.55469 13.243V13.9297H2.38281V13.243C2.38281 12.1192 2.80731 11.0172 3.55469 10.1812V9.82812H2.38281V10.4141H1.21094V8.65625H4.72656V10.6567Z",
    fill: "#fff",
    fillOpacity: 0.87
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89844 6.3125V15.6875H12.7578V6.3125H6.89844ZM11.5859 10.6567L11.4143 10.8283C10.7786 11.464 10.4141 12.3441 10.4141 13.243V13.9297H9.24219V13.243C9.24219 12.1192 9.66669 11.0172 10.4141 10.1812V9.82812H9.24219V10.4141H8.07031V8.65625H11.5859V10.6567Z",
    fill: "#fff",
    fillOpacity: 0.87
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7578 15.6875H19.6562V6.3125H13.7578V15.6875ZM14.9297 8.65625H18.4453V10.6567L18.2737 10.8283C17.638 11.464 17.2734 12.3441 17.2734 13.243V13.9297H16.1016V13.243C16.1016 12.1192 16.5261 11.0172 17.2734 10.1812V9.82812H16.1016V10.4141H14.9297V8.65625Z",
    fill: "#fff",
    fillOpacity: 0.87
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.6875H20V19.0312H0V16.6875Z",
    fill: "#fff",
    fillOpacity: 0.87
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoJackpotWidget);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_jackpot_widget.e37e1aae0a60e54d141193cb9e406215.svg";